import {
  Component,
  ElementRef,
  EventEmitter,
  Inject,
  Input,
  OnDestroy,
  OnInit,
  Output,
  PLATFORM_ID,
  ViewChild,
} from "@angular/core";
import { BsModalRef } from "ngx-bootstrap/modal";
import { ImageCropperComponent, ImageTransform } from "ngx-image-cropper";
import { Subject } from "rxjs";

@Component({
  selector: "app-image-capturer",
  templateUrl: "./image-capturer.component.html",
  styleUrls: ["./image-capturer.component.scss"],
})
export class ImageCapturerComponent implements OnInit, OnDestroy {
  @ViewChild("player", { static: true }) public player: ElementRef<HTMLVideoElement>;
  @ViewChild("canvas", { static: true }) public canvas: ElementRef<HTMLCanvasElement>;
  @ViewChild(ImageCropperComponent) public imageCropper: ImageCropperComponent;

  @Output() public openCapturer = new EventEmitter<void>();

  private _stream: MediaStream;
  @Input() public set stream(newStream: MediaStream) {
    this._stream = newStream;
    this.startCamara();
  }

  public get stream(): MediaStream {
    return this._stream;
  }

  public captureImage = new Subject<string>();

  public isCapturing: boolean = true;
  public imageDataUrl: string;

  public scale: number = 1;
  public minScale: number = 1;
  public maxScale: number = 3;
  public scalePercentage: number = 1;

  public rotation: number = 0;
  public minRotation: number = -50;
  public maxRotation: number = 50;
  public rotationPercentage: number = 50;

  public transform: ImageTransform;

  // eslint-disable-next-line @typescript-eslint/ban-types
  constructor(@Inject(PLATFORM_ID) private _platform: Object, private bsModalRef: BsModalRef) {}

  public ngOnInit(): void {
    this.updateTransform();
    this.startCamara();
  }

  public startCamara(): void {
    const video = this.player.nativeElement;
    video.srcObject = this.stream;
    video.play();
  }

  public onCaptureImage(): void {
    const canvas = this.canvas.nativeElement;
    const player = this.player.nativeElement;
    const context = canvas.getContext("2d");

    canvas.width = player.clientWidth / 1.5;
    canvas.height = player.clientHeight / 1.5;
    context.drawImage(player, 0, 0, canvas.width, canvas.height);
    this.imageDataUrl = canvas.toDataURL();

    this.stopVideo();
  }

  public stopVideo(): void {
    this.isCapturing = false;
    const player = this.player.nativeElement;
    if (player) {
      player.pause();
      (player.srcObject as MediaStream)?.getVideoTracks()[0].stop();
      player.srcObject = null;
    }
  }

  public onChangeZoom(event: Event): void {
    this.scale = +(event.target as HTMLInputElement).value;
    this.scalePercentage = ((this.scale - this.minScale) / (this.maxScale - this.minScale)) * 100;
    this.updateTransform();
  }

  public onChangeRotation(event: Event): void {
    this.rotation = +(event.target as HTMLInputElement).value;
    this.rotationPercentage = ((this.rotation - this.minRotation) / (this.maxRotation - this.minRotation)) * 100;
    this.updateTransform();
  }

  public updateTransform(): void {
    this.transform = { scale: this.scale, rotate: this.rotation };
  }

  public saveImage(): void {
    const { base64 } = this.imageCropper.crop();
    this.captureImage.next(base64);
  }

  public close(): void {
    if (this.isCapturing) {
      this.bsModalRef.hide();
    } else {
      this.isCapturing = true;

      navigator.mediaDevices
        .getUserMedia({ video: true })
        .then((stream) => {
          this.stream = stream;
          this.startCamara();
        })
        .catch(console.error);
    }
  }

  public ngOnDestroy(): void {
    this.stopVideo();
  }
}
